<template>
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="12" md="12" class="text-center">
          <v-color-picker v-model="content" style="margin: 0 auto" />
          <v-btn
            class="mx-2"
            style="margin: 0 auto"
            color="accent"
            @click="saveColor"
            :disabled="disabledSave"
            >{{ $t("common.saveColor") }}</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <h3 v-if="isInType(type, [ModuleTypes.GAUGE])">
            {{ $t("common.alarmColorPrecedence") }}
          </h3>
          <v-container>
            <palette-chip
              v-for="(c, i) in lmetas"
              v-bind:key="c.content"
              :color="c.content"
              :metas="metas"
              :type="type"
              :meta="c"
              :localMeta="lmetas"
              :fieldNames="fieldNames"
              class="ma-2"
              v-on:update="(m) => updateMeta(i, m)"
              v-on:remove="removeFromPalette(i)"
            >
            </palette-chip>
          </v-container>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ModuleTypesMixin from "@/_helpers/ModuleTypeHelper.js";
import PaletteChip from "@/components/common/PaletteChip";

export default {
  name: "StylePickerModule",
  mixins: [ModuleTypesMixin],
  props: {
    type: {
      default: null,
    },
    metas: {
      default: [],
    },
  },

  data() {
    return {
      content: "#FEFEFE",
      value: "",
      valueMatch: "",
      localMeta: [],
      fieldNames: [],
    };
  },

  async created() {
    this.getTags();
    if (this.metas.length > 0)
      this.localMeta = this.metas.filter((m) =>
        m.key.startsWith("so_style_meta")
      );
  },

  computed: {
    ...mapState("tag", ["tags"]),

    disabledSave() {
      if (
        this.isInType(this.type, [this.ModuleTypes.TRENDCHART]) &&
        this.localMeta.length > 0
      ) {
        return true;
      } else if (
        this.isInType(this.type, [this.ModuleTypes.TILTCHART]) &&
        this.localMeta.length > 1
      ) {
        return true;
      }

      return false;
    },

    lmetas() {
      return this.localMeta;
    },
  },

  methods: {
    ...mapActions("tag", ["getTags"]),
    constructAvaliableFieldNames() {
      let fieldNames = [];
      for (var i in this.metas) {
        // Find the tag of this
        if (!this.metas[i].value && !this.metas[i].valueMatch) continue;

        for (var j in this.tags) {
          if (this.metas[i].value == this.tags[j].deveui) {
            let n = `${this.tags[j].name} - ${this.metas[i].valueMatch}`;
            fieldNames.push({
              name: n,
              disabled:
                this.localMeta.length > 0 &&
                this.localMeta.filter((lm) => lm.value == n).length <= 0
                  ? false
                  : true,
            });
          }
        }
      }

      return fieldNames;
    },
    saveColor() {
      // Force the range picker to have one value atleast
      if (this.isInType(this.type, [this.ModuleTypes.GAUGE])) {
        this.value = 100;
        this.valueMatch = 100;
      }

      this.localMeta.push({
        key: "so_style_meta_color",
        content: this.content,
        value: this.value,
        valueMatch: this.valueMatch,
      });

      this.fieldNames = this.constructAvaliableFieldNames();
      this.$emit("update", this.localMeta);
    },

    updateMeta(i, meta) {
      this.localMeta[i] = meta;
      this.fieldNames = this.constructAvaliableFieldNames();
      this.$emit("update", this.localMeta);
    },

    removeFromPalette(index) {
      this.localMeta.splice(index, 1);
      this.fieldNames = this.constructAvaliableFieldNames();
      this.$emit("update", this.localMeta);
    },
  },

  components: {
    PaletteChip,
  },

  watch: {
    metas() {
      this.fieldNames = this.constructAvaliableFieldNames();
    },
  },
};
</script>

<style>
.theme--dark.v-color-picker input {
  color: #fff !important;
}
</style>